/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';
import ErrorLayout from '../layouts/Error';
import CustomerLayout from '../layouts/Customer';

const routes = [
  {
    path: '/',
    exact: true,
    component: () => <Redirect to="/errors" />
  },
  {
    path: '/static-page',
    component: CustomerLayout,
    routes: [
      {
        path: '/static-page/:id',
        exact: true,
        component: lazy(() => import('../views/StaticPage'))
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  }
];

export default routes;
